module.exports = __webpack_public_path__ + "static/media/storm_page9.81576240.png";